// Module
var code = "<span> {{vm.quantity}} {{vm.quantity > 1 ? vm.labelPlural : vm.labelSingular}} </span> ";
// Exports
module.exports = code;